module.exports = __webpack_public_path__ + "img/arrow.ec7437c3.svg";